/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_UnsupportedInputs */



/**
* | output |
* | --- |
* | "This browser cannot record. Update your browser and try again." |
*
* @param {Meeting_Offline_UnsupportedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_unsupported = /** @type {((inputs?: Meeting_Offline_UnsupportedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_UnsupportedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Deze browser kan niet opnemen. Werk je browser bij en probeer opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce navigateur ne peut pas enregistrer. Mettez votre navigateur à jour et réessayez.")
	return /** @type {LocalizedString} */ ("This browser cannot record. Update your browser and try again.")
});